const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/smart_scale/smart_scale_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.smart_scale.powerDevice.title',
    secondaryTx: 'categories.smart_scale.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.smart_scale.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/smart_scale/smart_scale_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.smart_scale.confirmPairingMode.title',
    secondaryTx: 'categories.smart_scale.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.smart_scale.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.smart_scale.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/smart_scale/reset_scale_step_1.png'),
          primaryTx: 'categories.smart_scale.resetDevice.step1.title',
          secondaryTx: 'categories.smart_scale.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/smart_scale/reset_scale_step_2.png'),
          primaryTx: 'categories.smart_scale.resetDevice.step2.title',
          secondaryTx: 'categories.smart_scale.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/smart_scale/reset_scale_step_3.gif'),
          primaryTx: 'categories.smart_scale.resetDevice.step3.title',
          secondaryTx: 'categories.smart_scale.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
